
import { Options, Vue } from "vue-class-component";
import { downloadFile } from "@/app/infrastructures/misc/Utils";
import DetailLayout from "@/app/ui/layout/detail-layout.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import {
  ConfigBucketStorage,
  configBucketTemplateFiles
} from "@/feature-flags/flags-config-bucket-storage";
import { FlagsBulkDownloadTemplate, FlagsBcsBulkDownloadTemplate } from "@/feature-flags/flags-bulk-download-template";

@Options({
  components: {
    DetailLayout
  }
})
export default class TabTemplate extends Vue {
  //   Search
  searchValue = "";
  onSearch(value: string) {
    this.searchValue = value;
  }
  onClearSearch() {
    this.searchValue = "";
  }

  get filteredStepFillTemplate() {
    return this.tempList.filter(item =>
      this.searchValue
        ? item.title.toLowerCase().includes(this.searchValue.toLowerCase())
        : true
    );
  }

  get accountType() {
    return AccountController.accountData.account_type;
  }

  get suffixBulkDownloadClient() {
    const isAccountForeign = AccountController.accountData.accountIsForeign;
    return isAccountForeign ? "en" : "id";
  }

  stepFillTemplate = [
    {
      title: "List of Permission",
      description: "Template List of Permission",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis_announcement.getValue()}/template-role-20210628.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_permission_list.isEnabled()
    },
    {
      title: "Role",
      description: "Template role",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis_announcement.getValue()}/role1608520351.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_role.isEnabled()
    },
    {
      title: "Account",
      description: "Template account",
      url: configBucketTemplateFiles.getValue().account,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_account.isEnabled()
    },
    {
      title: "Manajemen Pelanggan",
      description: "Template manajemen pelanggan",
      url: configBucketTemplateFiles.getValue().customer_management,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_manajemen_pelanggan.isEnabled()
    },
    {
      title: "Create Kategori Komoditas",
      description: "Template Create Kategori Komoditas",
      url: `https://dev-genesis.s3.ap-southeast-1.amazonaws.com/create_kategori_komoditas_01_2025.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_create_kategori_komoditas.isEnabled()
    }
  ];

  internalTemplate = [
    {
      title: "Syarat dokumen internasional",
      description: "Template syarat dokumen internasional.  ",
      url: `https://dev-genesis.s3.ap-southeast-1.amazonaws.com/add_document_international_122024.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_syarat_dokumentasi_internasional.isEnabled()
    },
    {
      title: "Route Mapping",
      description: "Template route mapping",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis_announcement.getValue()}/route1608520197.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_route_mapping.isEnabled()
    },
    {
      title: "Commodity",
      description: "Template commodity",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/bulk/template/commodity_01_2025.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_add_commodity.isEnabled()
    },
    {
      title: "Create Commodity Surcharge",
      description: "Template for create commodity surcharge",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/template_create_commodity_surcharge_2023-11-13.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_create_commodity_surcharge.isEnabled()
    },
    {
      title: "Update Commodity Surcharge",
      description: "Template for update commodity surcharge",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/template-commodity-surcharge-2023-10-31.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_update_commodity_surcharge.isEnabled()
    },
    {
      title: "Leg",
      description: "Template leg",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis_announcement.getValue()}/leg1608520110.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_donwload_template_leg.isEnabled()
    },
    {
      title: "Route Leg",
      description: "Template route leg",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis.getValue()}/TemplateBulkRouteLeg24072023.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_route_leg.isEnabled()
    },
    {
      title: "Route",
      description: "Template route",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis_announcement.getValue()}/template-route-20210628.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_route.isEnabled()
    },
    {
      title: "Transport Vendor",
      description: "Template transport vendor",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis_announcement.getValue()}/transport1608520423.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_transport_vendor.isEnabled()
    },
    {
      title: "Vendor",
      description: "Template vendor",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis_announcement.getValue()}/vendor1608520494.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_vendor.isEnabled()
    },
    {
      title: "Mapping Client Location",
      description: "Template mapping client location",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis_announcement.getValue()}/template-client-location-mapping-20210628.xlsx`,
      extension: "xlsx",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_mapping_client_location.isEnabled()
    },
    {
      title: "Genesis Commodity & Mapping to ECARGO Commodity",
      description: "Template Genesis Commodity & Mapping to ECARGO Commodity",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis_announcement.getValue()}/template-commodity-20210628.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_commodity_stt_and_mapping_group.isEnabled()
    },
    {
      title: "Add new retail base rate",
      description: "Template Add new retail base rate",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis_announcement.getValue()}/add-new-retail-base-rate-2026-08-10.xlsx`,
      extension: "xlsx",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_add_new_retail_base_rate.isEnabled()
    },
    {
      title: "Bagging Group Location",
      description: "Template Bagging Group Location",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/template/template_bagging_grouping.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_bagging_group_location.isEnabled()
    },
    {
      title: "SLA District",
      description: "Template SLA District",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/template/update_sla_district.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_sla_district.isEnabled()
    },
    {
      title: "Create SLA City",
      description: "Template Create SLA City",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/template/create_sla_city.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_create_sla_city.isEnabled()
    },
    {
      title: "Update SLA City",
      description: "Template Update SLA City",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/template/update_sla_city.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_update_sla_city.isEnabled()
    },
    {
      title: "Add Embargo",
      description: "Template Add Embargo",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis.getValue()}/add_embargo_1674101951.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_add_embargo.isEnabled()
    },
    {
      title: "Update Embargo",
      description: "Template Update Embargo",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis.getValue()}/update_embargo_1674102029.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_update_embargo.isEnabled()
    },
    {
      title: "Update Country",
      description: "Template Update Country",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis.getValue()}/update_country_1674102229.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_update_country.isEnabled()
    },
    {
      title: "Add Country",
      description: "Template Add Country",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis.getValue()}/add_country_1674102317.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_add_country.isEnabled()
    },
    {
      title: "Update City",
      description: "Template Update City",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis.getValue()}/update_city_1674102392.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_update_city.isEnabled()
    },
    {
      title: "Add City",
      description: "Template Add City",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis.getValue()}/add_city_1674102441.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_add_city.isEnabled()
    },
    {
      title: "Update District",
      description: "Template Update District",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/bulk/template/update_district_02102026.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_update_district.isEnabled()
    },
    {
      title: "Add District",
      description: "Template Add District",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/bulk/template/add_district_02102026.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_add_district.isEnabled()
    },
    {
      title: "Config Cargo",
      description: "Template Config Cargo",
      url: `https://prd-genesis.s3.ap-southeast-1.amazonaws.com/bulk/template/config_cargo_102025.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_config_cargo.isEnabled()
    },
    {
      title: "AWB Reserve",
      description: "Template AWB Reserve",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis.getValue()}/Upload-Reserve-AWB-Number.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_awb_reserve.isEnabled()
    },
    {
      title: "Region",
      description: "Template Region",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis.getValue()}/add_region.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_region.isEnabled()
    },
    {
      title: "Region City",
      description: "Template Region City",
      url: `${ConfigBucketStorage.config_bucket_dev_genesis.getValue()}/add_region_city.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_region_city.isEnabled()
    },
    {
      title: "Kargo Grouping",
      description: "Template Kargo Grouping",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/bulk/template/rtc_city_group_1686634062.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_kargo_grouping.isEnabled()
    },
    {
      title: "Create Promo Discount",
      description: "Template Create Promo Discount",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/bulk/template/Add%20Promo%20Discount.xlsx`,
      extension: "xlsx",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_create_promo_discount.isEnabled()
    },
    {
      title: "Update Promo Discount",
      description: "Template Update Promo Discount",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/bulk/template/update_promo_discount_20230808.xlsx`,
      extension: "xlsx",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_update_promo_discount.isEnabled()
    },
    {
      title: "Update Commodity",
      description: "Template Update Commodity",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/bulk/template/update_commodity_01_2025.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_update_commodity.isEnabled()
    },
    {
      title: "Custom Status",
      description: "Update Custom Status HALCD & CNXCD",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/custom_status/update_custom_status_halcd_and_cnxcd.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_custom_status.isEnabled()
    },
    {
      title: "District Code Vendor Interpack",
      description: "Template District Code Vendor Interpack",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/bulk/template/district_vendor.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_district_code_vendor_internpack.isEnabled()
    },
    {
      title: "Area Keterlambatan",
      description: "Template Area Keterlambatan",
      url: `${ConfigBucketStorage.config_bucket_prd_genesis.getValue()}/bulk/template/area_keterlambatan_022025.csv`,
      extension: "csv",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_area_keterlambatan.isEnabled()
    },
    {
      title: "Booking domestik",
      description: "Template Booking domestik",
      url: `${FlagsBcsBulkDownloadTemplate.config_bucket_storage.getValue()}/bulk-booking-template-client.xlsx`,
      extension: "xlsx",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_booking_domestik_configuration.isEnabled()
    },
    {
      title: "Booking internasional",
      description: "Template Booking internasional",
      url: `${FlagsBcsBulkDownloadTemplate.config_bucket_storage.getValue()}/bulk-booking-international-${
        this.suffixBulkDownloadClient
      }.xlsx`,
      extension: "xlsx",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_booking_internasional_configuration.isEnabled()
    },
    {
      title: "Limit Tagihan POS",
      description: "Template Limit Tagihan POS",
      url: `${FlagsBcsBulkDownloadTemplate.config_bucket_storage.getValue()}/bulk/template/pos-limit.xlsx`,
      extension: "xlsx",
      templateKey: "pos_limit",
      cardTestId: "bulk-download-template-pos-limit-config",
      downloadTestId: "bulk-download-template-pos-limit-download",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_pos_limit.isEnabled()
    },
    {
      title: "Konversi Mata Uang",
      description: "Template Konversi Mata Uang",
      url: `${FlagsBcsBulkDownloadTemplate.config_bucket_storage.getValue()}/bulk/template/exchange_rate_config.xlsx`,
      extension: "xlsx",
      templateKey: "exchange_rate_config",
      cardTestId: "bulk-download-template-card-exchange-rate-config",
      downloadTestId: "bulk-download-template-card-exchange-rate-config-download",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_exchange_rate_config.isEnabled()
    },
    {
      title: "Duty Tax",
      description: "Template Duty Tax",
      url: `${FlagsBcsBulkDownloadTemplate.config_bucket_storage.getValue()}/bulk/template/duty_tax_configuration_template.csv`,
      extension: "csv",
      templateKey: "duty_tax_configuration",
      cardTestId: "bulk-download-template-card-duty-tax",
      downloadTestId: "bulk-download-template-card-duty-tax-download",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_duty_tax.isEnabled()
    }
  ];

  get tempList() {
    if (this.accountType) {
      if (this.accountType === "internal") {
        return [...this.stepFillTemplate, ...this.internalTemplate];
      }
      return this.stepFillTemplate;
    }
    return [];
  }

  onDownload(url: string, filename: string, extension: string) {
    downloadFile(url, filename, extension);
  }
}
